import { getKnowledgebaseMenu } from '@/Groups/KnowledgeBase/private/api/getKnowledgeBase';
import { getKnowledgebasePage } from '@/Groups/KnowledgeBase/private/api/getKnowledgebasePage';

export default {
  namespaced: true,

  state: {
    menu: [],
    loading: false,
    error: null,
    initialized: false,
    activeId: null,

    page: null,
    pageLoading: false,
    pageError: null,
  },

  actions: {
    async init({ state, dispatch }, slug) {
      if (state.initialized) return;
      await dispatch('fetchMenu', slug);
    },

    async fetchMenu({ commit, dispatch }, slug) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      try {
        const data = await getKnowledgebaseMenu();
        const menu = data.results || [];

        commit('SET_MENU', menu);
        commit('SET_INITIALIZED', true);

        if (slug) {
          await dispatch('setActiveBySlug', slug);
        } else {
          await dispatch('setFirstActive');
        }
      } catch (error) {
        commit('SET_ERROR', error.message);
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async setFirstActive({ state, commit, dispatch }) {
      if (!state.menu.length) return;
      const firstSection = state.menu[0];
      const firstSubmenu = firstSection?.menus?.[0];
      if (firstSubmenu) {
        commit('SET_ACTIVE_ID', firstSubmenu.id);
        const firstPageId = firstSubmenu.pages?.[0]?.id;
        if (firstPageId) {
          await dispatch('fetchPage', firstPageId);
        }
      }
    },

    //Меняем активный таб по ID
    async setActive({ commit, dispatch, state }, id) {
      const submenu = state.menu
        .flatMap(section => section.menus)
        .find(m => m.id === id);

      commit('SET_ACTIVE_ID', id);

      const pageId = submenu?.pages?.[0]?.id || null;

      if (pageId) {
        await dispatch('fetchPage', pageId);
      } else {
        commit('SET_PAGE', null);
      }
    },

    async setActiveBySlug({ state, commit, dispatch }, slug) {
      for (const section of state.menu) {
        for (const submenu of section.menus) {
          if (submenu.slug === slug) {
            commit('SET_ACTIVE_ID', submenu.id);

            const pageId = submenu.pages?.[0]?.id;
            if (pageId) await dispatch('fetchPage', pageId);

            return;
          }
        }
      }

      await dispatch('setFirstActive');
    },

    // Получение контента страницы
    async fetchPage({ commit }, pageId) {
      commit('SET_PAGE_LOADING', true);
      commit('SET_PAGE_ERROR', null);

      try {
        const data = await getKnowledgebasePage(pageId);
        commit('SET_PAGE', data);
      } catch (error) {
        commit('SET_PAGE_ERROR', error.message);
      } finally {
        commit('SET_PAGE_LOADING', false);
      }
    },
  },

  mutations: {
    SET_MENU(state, menu) {
      state.menu = menu;
    },
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_INITIALIZED(state, value) {
      state.initialized = value;
    },
    SET_ACTIVE_ID(state, id) {
      state.activeId = id;
    },
    SET_PAGE(state, page) {
      state.page = page;
    },
    SET_PAGE_LOADING(state, value) {
      state.pageLoading = value;
    },
    SET_PAGE_ERROR(state, error) {
      state.pageError = error;
    },
  },

  getters: {
    getMenu: (state) => state.menu,
    isLoading: (state) => state.loading,
    getError: (state) => state.error,
    isInitialized: (state) => state.initialized,
    getActiveId: (state) => state.activeId,

    getPage: (state) => state.page,
    isPageLoading: (state) => state.pageLoading,
    getPageError: (state) => state.pageError,
  },
};